import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  contentContainer: {
    '@media (max-width: 768px)': {
      paddingTop: '85px',
    },
  },
  gridContainer: {
    marginTop: '24px!important',
  },
  fieldParent: {
    marginBottom: '24px',
    '@media (max-width: 768px)': {
      marginBottom: '16px',
    },
  },
  orText: {
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT4,
    margin: '16px 0',
    display: 'flex',
    alignItems: 'center',
    '&::before, &::after': {
      content: '""',
      flex: 1,
      borderBottom: `1px dashed ${STYLE.COLOR.BORDER_DASHED}`,
    },
    '&::before': {
      marginRight: '16px',
    },
    '&::after': {
      marginLeft: '16px',
    },
    width: '60%',
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '32px',
    gap: '12px',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
      marginTop: '24px',
      flexDirection: 'column-reverse',
    },
  },
  button: {
    minWidth: '180px !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  backButton: {
    minWidth: '140px !important',
    whiteSpace: 'nowrap',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  successIcon: {
    width: '80px',
    height: '80px',
    marginBottom: '16px',
  },
  successTitle: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '40px',
    maxWidth: '400px',
  },
  successButton: {
    minWidth: '200px !important',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
}));
